/**
 * Códigos de erro da aplicação.
 * Para mais informações ver: https://confluence-itau.tecnologia.prod.ops.aws.cloud.ihf/pages/viewpage.action?pageId=640307764
 */
export enum ErrorCodes {
  UNKNOWN = 'IT-0000',
  INVALID_LOGIN_SCREEN = 'IT-0008',
  INVALID_CLIENT_PROXY = 'IT-0009',
  ERROR_CIAM = 'IT-0010',
  INVALID_CHARON_PROXY = 'IT-0011',
  INVALID_CHARON_TOKEN_RECOVERY = 'IT-0012',
  INVALID_MFE = 'IT-0013',
  NOT_FOUND_URL = 'IT-0032'
}
